import React, { useCallback } from 'react';

import { Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

import { getBusinessAdminSpoofingLink } from '~/services/BusinessTraveller/BusinessTravellerService';

import PortalSpoofButton from './PortalSpoofButton';

interface Props {
  user: App.User;
  buttonSx?: SxProps<Theme>;
}

function BusinessAdminSpoofButton({ user, buttonSx }: Props) {
  const generateSpoofingLink = useCallback(
    () => getBusinessAdminSpoofingLink({ customerId: user.id_member }),
    [user.id_member],
  );

  return (
    <PortalSpoofButton
      buttonLabel="Business admin spoofing link"
      dialogTitle={
        <>
          Spoofing link for business admin{' '}
          <Typography component="span" variant="inherit" fontStyle="italic">
            {user.email}
          </Typography>
        </>
      }
      generateSpoofingLink={generateSpoofingLink}
      buttonSx={buttonSx}
    />
  );
}

export default BusinessAdminSpoofButton;
